const e = "styles-module__extras_container___ycdxY", _ = "styles-module__header___ytER0", t = "styles-module__title___pbBqR", o = "styles-module__delete_room___oAjQy", s = "styles-module__body___Jc9S0", l = {
  extras_container: e,
  header: _,
  title: t,
  delete_room: o,
  body: s
};
export {
  s as body,
  l as default,
  o as delete_room,
  e as extras_container,
  _ as header,
  t as title
};
